// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"b06e84fb","343":"2bfec502","345":"d5967648","353":"14042229","395":"161a7d08","418":"0b0d0297","453":"022d9a97","485":"20954494","670":"e1be8bac","735":"caffb621","791":"842d95a2","811":"9e6e4e5b","823":"e9895e0a","895":"057a32b2","945":"ab7bb723","951":"f439d96e"}[chunkId] + ".chunk.js";
};